import { post, get, baseURL } from "@/utils/request";

// i18n API
export const getI18nList = (data: any) => post(`/common/i18n/keyMaps`, data);

// Get Activity data 
export const getActivityInformations = (params: any) => post(`/activity/info`, params);

// Get Activity List 
export const getActivityList = () => get(`/activity/activityList`);
//PWA 
export const getPWADomain = (param : any) => get(`/pwaReward/domain/${param.id}`);
//PWA 
export const getPWADomainInfo = () => get(`/pwaReward/domain/info`);

export const getHomeActivityList = () => get(`/activity/homeActivityList`);

//Agent Info
export const getAgentInfo = () => get(`/activity/agentInfo`);

//All game list
export const getAllGame = (param : any) => post(`/v1/mgame/getAllGameList?pageNum=${param.pageNum}&pageSize=${param.pageSize}&search=${param.searchText}`);

export const getTodayRewards = () => get(`/activity/todayRewards`);